<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:39:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-02-09 09:54:23
-->
<template>
  <div class="right">
    <div class="rightTop">
      <cockpit-title title="码上活动列表" enTitle="mshd" />
      <div class="echartsBox">
        <code-activity></code-activity>
      </div>
    </div>
    <div class="right-enter">
      <cockpit-title title="丽企大讲堂数据" enTitle="lsdjt" />
      <div class="center">
        <RightCenter></RightCenter>
      </div>
    </div>
    <div class="right-bottom">
      <cockpit-title title="服务券数据" enTitle="fwqsj" />
      <div class="bottom">
        <RightBottom></RightBottom>
      </div>
    </div>
  </div>
</template>

<script>
import cockpitTitle from '../cockpit-title.vue'
import CodeActivity from './top.vue'
import RightCenter from './middle.vue'
import RightBottom from './bottom.vue'
export default {
  name: 'Right',
  components: { cockpitTitle, CodeActivity, RightCenter, RightBottom }
}
</script>

<style lang="scss" scoped>
.right {
  height: 100%;
  margin-top: 2%;
  > div {
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    height: calc((100% - 1rem) / 3);
    margin-bottom: 0.1rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &-Top {
    width: 100%;
    height: 80%;
  }
  .right-enter {
    margin-top: 12%;
  }
  .right-bottom {
    margin-top: 7.5%;
  }
  .echartsBox,
  .center,
  .bottom {
    width: 100%;
    height: 100%;
  }
}
</style>
